import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { BaasicFormControls, BasicFieldCheckbox, BaasicButton, BasicInput } from 'core/components';

function BackOrderEditModalTemplate({ backOrderEditModalViewStore , t}) {
    const {
        form,
        modalParams
    } = backOrderEditModalViewStore;

    return (
        <section>
            <div className="modal__header">
                <h3 className='modal__header__title'>Edit Backorder</h3>
            </div>
            <div className="modal__body">
                <div className="form__group">
                    <BasicFieldCheckbox className="has-fake-label"  field={form.$('backOrder')} /><span className="fake-label">On Backorder</span>
                </div>
                <div className="form__group">
                    <BasicInput field={form.$('backOrderNote')} /> 
                </div>
            </div>
            <div className='modal__footer'>
                <BaasicFormControls
                className='btn btn--med btn--primary'
                    form={form} 
                    onSubmit={form.onSubmit} 
                    disabled={form.submitting || form.validating} 
                    label="Submit"
                />  
                <BaasicButton
                    className='btn btn--med btn--light'
                    label={t('EDIT_FORM_LAYOUT.CANCEL')}
                    onClick={() => modalParams.close()}
                />
            </div>
        </section> 
    )
}
 
BackOrderEditModalTemplate.propTypes = {
    backOrderEditModalViewStore: PropTypes.object,
    t: PropTypes.func
};

export default defaultTemplate(BackOrderEditModalTemplate);
